import { useContext, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Collapse } from 'antd';
import {
    X, Plus, ChevronDown
} from 'lucide-react';
import { NAV_ITEMS } from '@utils/navConfig';
import logo from '@assets/logo/fnotrader.png'
import './MobileDrawer.scss';

const QUIKTRADE_URL = import.meta.env.VITE_QUIKTRADE_URL
    ?? (window.location.href.includes('beta')
        ? 'https://beta-quiktrade.fnotrader.com/home'
        : 'https://quiktrade.fnotrader.com/home');

const MobileDrawer = ({ open, onClose }) => {
    const { pathname } = useLocation();

    const handleLinkClick = () => onClose();

    const collapseItems = NAV_ITEMS.map(item => {
        const hasActiveChild = item.items ? item.items.some(child => child.path === pathname) : false;
        const isParentActive = pathname === item.path || hasActiveChild;

        return {
            key: item.key,
            label: (
                <span className={`drawer-accordion__label${isParentActive ? ' drawer-accordion__label--active' : ''}`}>
                    {item.label}
                </span>
            ),
            children: (
                <div className="drawer-accordion__links">
                    {item.items
                        ? item.items.map(i => {
                            const isSubActive = pathname === i.path;
                            return (
                                <Link
                                    key={i.path}
                                    to={i.path}
                                    className={`drawer-link${isSubActive ? ' drawer-link--active' : ''}`}
                                    onClick={handleLinkClick}
                                >
                                    {i.label}
                                </Link>
                            );
                        })
                        : (
                            <Link 
                                to={item.path} 
                                className={`drawer-link${pathname === item.path ? ' drawer-link--active' : ''}`} 
                                onClick={handleLinkClick}
                            >
                                {item.label}
                            </Link>
                        )
                    }
                </div>
            ),
        };
    });

    return (
        <>
            {/* Overlay */}
            <div
                className={`drawer-overlay${open ? ' drawer-overlay--visible' : ''}`}
                onClick={onClose}
            />

            {/* Drawer panel */}
            <div className={`mobile-drawer${open ? ' mobile-drawer--open' : ''}`}>

                {/* Header */}
                <div className="drawer-header">
                    <Link to="/pages/technical-analysis" className="drawer-logo" onClick={handleLinkClick}>
                        <img src={logo} alt="logo" />
                        <span>Discover</span>
                    </Link>
                    <button className="drawer-close" onClick={onClose} aria-label="Close menu">
                        <X size={18} />
                    </button>
                </div>

                {/* Nav accordion */}
                <div className="drawer-nav">
                    <Collapse
                        items={collapseItems}
                        ghost
                        expandIcon={({ isActive }) => (
                            <ChevronDown
                                size={14}
                                strokeWidth={2.5}
                                style={{ transform: isActive ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
                            />
                        )}
                        expandIconPlacement="end"
                    />
                </div>

                {/* Bottom actions */}
                <div className="drawer-footer">
                    <Link
                        to="/account/broker-login"
                        className="drawer-btn drawer-btn--outline"
                    >
                        <Plus size={13} /> Add Broker
                    </Link>

                    <a
                        href={QUIKTRADE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="drawer-btn drawer-btn--quiktrade"
                        onClick={onClose}
                    >
                        <span className="quik">Quik</span><span className="trade">Trade</span>
                    </a>
                </div>

            </div>
        </>
    );
};

export default MobileDrawer;